import { NavLink } from "react-router-dom";
import { LogOut, Moon, Sun } from "lucide-react";
import { cn } from "@/lib/utils";
import { can, ROLE_LABEL } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";
import { useThemeMode } from "@/context/ThemeContext";
import { BrandMark, UserAvatar } from "@/components/common";
import { NAV } from "./nav";

export default function Sidebar() {
  const { user, logout } = useAuth();
  const { theme, toggle } = useThemeMode();
  const items = NAV.filter((n) => !n.m || can(user, n.m));
  return (
    <aside className="sticky top-0 hidden h-screen w-64 shrink-0 flex-col border-r bg-card md:flex" data-testid="desktop-sidebar">
      <div className="px-5 py-5">
        <BrandMark />
      </div>
      <nav className="flex-1 space-y-1 px-3 py-2">
        {items.map(({ to, label, icon: Icon, key }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={`sidebar-${key}-link`}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors",
                isActive ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-secondary hover:text-foreground",
              )
            }
          >
            <Icon className="h-4 w-4" />
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="border-t p-4 space-y-3">
        <button
          data-testid="sidebar-theme-toggle"
          onClick={toggle}
          className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground"
        >
          {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          {theme === "dark" ? "Light mode" : "Dark mode"}
        </button>
        <div className="flex items-center gap-3 rounded-xl bg-secondary/60 p-3">
          <UserAvatar user={user} size="md" />
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-semibold" data-testid="sidebar-user-name">{user?.name}</p>
            <p className="text-[11px] text-muted-foreground" data-testid="sidebar-user-role">
              {ROLE_LABEL[user?.role]}
              {user?.is_partner && user?.role !== "partner" ? " · Partner" : ""}
            </p>
          </div>
          <button data-testid="sidebar-logout-button" onClick={logout} title="Log out" className="rounded-md p-1.5 text-muted-foreground hover:bg-background hover:text-foreground">
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </div>
    </aside>
  );
}
